export const BUTTON_TEXTS = {
  choosePlan: 'Choose plan',
  contactUs: 'Contact us',
  toBusiness: 'Upgrade to Business Plan',
  toCreator: 'Upgrade to Creator Plan',
  toCreatorPro: 'Upgrade to Creator Pro Plan',
} as const;

export const BULLETS_HEADER_TEXT = {
  inBusiness: 'Everything in Business, plus:',
  inCreator: 'Everything in Creator, plus:',
  inCreatorPro: 'Everything in Creator Pro, plus:',
  inTrial: 'Everything in Trial, plus:',
  withBusiness: "With the Business plan, you'll get:",
  withCreator: "With the Creator plan, you'll get:",
  withCreatorPro: "With the Creator Pro plan, you'll get:",
} as const;
